export default "__VITE_ASSET__DYaKmzFi__"